// This is an empty shell needed for some packages not to crash
// when trying to inject the helpService
angular.module('backstage.services').factory('helpService', () => ({}));
